import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useState } from 'react';
import { TierFormulaBuilder } from './TierFormulaBuilder';
import { validateFormula } from './TierFormulaUtils';

/**
 * Dialog around TierFormulaBuilder. data: { formula, palette, thresholdFormula?, thresholdValueFormat?, readOnly? }
 * - thresholdValueFormat present -> the Tier supports a Threshold, edited alongside the formula
 * - readOnly -> formatted, non-editable view of the formula (and Threshold, if any) with just a Close button
 * Resolves with { formula, thresholdFormula } on Save, undefined on Cancel/Close.
 */
export const TierFormulaBuilderDialog = ({ data, closeDialog }) => {
  const { palette, thresholdValueFormat, readOnly } = data;
  const hasThreshold = thresholdValueFormat != null;

  const [formula, setFormula] = useState(data.formula ?? '');
  const [thresholdFormula, setThresholdFormula] = useState(data.thresholdFormula ?? null);
  const [error, setError] = useState(null);

  const submit = () => {
    const validationError =
      validateFormula(formula) ??
      (hasThreshold && thresholdFormula ? validateFormula(thresholdFormula) : null);
    if (validationError) {
      setError(validationError);
      return;
    }
    closeDialog({ formula, thresholdFormula: hasThreshold ? thresholdFormula : null });
  };

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth maxWidth="xl">
      <DialogTitle>{readOnly ? 'Formula' : 'Edit Formula'}</DialogTitle>
      <DialogContent>
        <TierFormulaBuilder
          formula={formula}
          onChange={(newFormula) => {
            setError(null);
            setFormula(newFormula);
          }}
          palette={palette}
          error={error}
          disabled={readOnly}
          threshold={
            hasThreshold ?
              { formula: thresholdFormula, onChange: setThresholdFormula, valueFormat: thresholdValueFormat }
            : null
          }
        />
      </DialogContent>
      <DialogActions>
        {readOnly ?
          <Button onClick={() => closeDialog()}>Close</Button>
        : <>
            <Button onClick={() => closeDialog()}>Cancel</Button>
            <Button variant="contained" onClick={submit}>
              Save
            </Button>
          </>
        }
      </DialogActions>
    </Dialog>
  );
};
